import React, { useState } from 'react';
import { Container } from './Styled';

interface EmailContainerProps {
    email: string;
    setEmail: (email: string) => void;
    isMailValid: (email: string) => boolean;
}

const EmailContainer = ({email, setEmail, isMailValid}: EmailContainerProps) => {
    const [isValid, setIsValid] = useState(true)
    const [errorMessage, setErrorMessage] = useState("")
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value);
    };

    const checkValidity = () => {
        if (! email) {
            setErrorMessage("Enter your email to continue")
        } else if (! isMailValid(email)) {
            setErrorMessage("Re-enter a valid email address in the correct format\n(e.g., yourname@example.com).")

        } else {
            setErrorMessage("")
        }
    }

    return (
        <div style={{fontFamily: "Inter, sans-serif", fontSize: "14px"}}>
            Email
            <Container>
                <input
                    type="email"
                    id="email"
                    value={email}
                    onChange={handleChange}
                    required
                    className="custom-input"
                    onBlur={() => checkValidity()}
                />
                <div className={`validation-error ${errorMessage ? '' : 'hidden'}`}>
                    {errorMessage}
                </div>
            </Container>
        </div>
    );
};

export default EmailContainer;
